var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pdfPage"}},[_c('div',[_c('button',{on:{"click":_vm.openPdf}},[_vm._v("Ouvrir PDF")])]),_c('br'),_c('div',[_c('button',{on:{"click":_vm.printPdf}},[_vm._v("Imprimer pdf")])])])}
var staticRenderFns = []

export { render, staticRenderFns }